import { useLayoutEffect } from 'react';

/**
 * Imperatively keep `document.title` in sync with the current page.
 *
 * Why not just rely on <Helmet>? In this client-only CRA + React 18 (`createRoot`)
 * app, react-helmet / react-helmet-async flush their head changes via a batched
 * side-effect that can lag a tick — or, on heavier routes, fail to apply on the
 * initial client render at all (the page is left showing index.html's default
 * title). Setting the title in a layout effect runs synchronously right after the
 * route mounts, so the correct title is always in place before the user sees it.
 *
 * Helmet still manages the rest of the head (description / og / canonical); this
 * just guarantees the one tag users actually see in the tab and search results.
 */
export default function useDocumentTitle(title) {
    useLayoutEffect(() => {
        if (title && document.title !== title) {
            document.title = title;
        }
    }, [title]);
}
